<script setup lang="ts">
import { FormInput, FormLabel, FormSelect, FormSwitch } from "@easy/ui/forms";
import { BlockDefinitionLinkField } from "@/apps/page/services/blocks/block.interfaces";
import { ref, ComputedRef, computed } from "vue";
import { useGetters } from "@/store/vuex-composition-mappers";
import { useI18n } from "vue-i18n";

enum LinkType {
    CUSTOM = "custom",
    TO_SECTION = "to-section",
}

interface SectionWebIdLink {
    label: string;
    value: string;
}

const { field, item } = defineProps<{
    field: BlockDefinitionLinkField;
    item: any;
}>();

const { t } = useI18n();

const linkTypes = computed(() => [
    { label: t("page.block.fields.linkTypeCustom"), value: LinkType.CUSTOM },
    { label: t("page.block.fields.linkTypeToSection"), value: LinkType.TO_SECTION },
]);

const selectedLinkType = ref(
    item[field.value] && item[field.value].startsWith("#") && item[field.value].length > 1
        ? LinkType.TO_SECTION
        : LinkType.CUSTOM
);

const { sectionWebIdLinks } = useGetters("page", ["sectionWebIdLinks"]) as {
    sectionWebIdLinks: ComputedRef<SectionWebIdLink[]>;
};
</script>

<template>
    <div class="space-y-2">
        <FormLabel>{{ field.label }}</FormLabel>
        <FormSwitch v-model="selectedLinkType" :options="linkTypes" />
        <FormInput
            v-if="selectedLinkType === LinkType.CUSTOM"
            :id="field.value"
            title=""
            v-model="item[field.value]"
        />
        <FormSelect
            v-if="selectedLinkType === LinkType.TO_SECTION"
            v-model="item[field.value]"
            label=""
            :options="sectionWebIdLinks"
            :value="item[field.value]"
        />
    </div>
</template>
